import axios from 'axios'
import router from '../src/router'
import serverName from "./serverName"
const s = serverName
// var prefix = '/api/portal-affairs/frontWeb' //本地
var prefix = 'api/portal-affairs/frontWeb'  //财经大学


// 创建 axios 实例
export default function Request( api, method, data, loading = true, head) {
    const loginUserId = sessionStorage.getItem('userId');
    //设置头部header
    const headers = {
        loginUserId
        // 'Content-Type': 'application/json;'
    }
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: '',
            timeout: 180000, // 请求超时时间            
        })
        instance({
            url: s != '' ? "/" + s + prefix + api : prefix + api,
            headers: head ? head : headers,
            method: method,
            data: data,
            reponseType: 'blob'
        }).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data)
            } else {
                reject(res.data)
            }
            resolve(res) //回调
        })
            .catch(err => {
                if (err.response.data.code == 631) {
                    router.push({
                        name: "login",
                    });
                } else {
                    reject(err.response.data) //回调
                }
            })
    })
}